import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useHistory } from 'react-router-dom';
import { ArrowLeftOutlined } from '@ant-design/icons';

import { getGoBackButtonInfo } from 'shared/lib/getGoBackButtonInfo';
import { BackToAppsStyled } from 'shared/ui/BackButton/BackButton.styles';

export const BackButton: FC = () => {
	const history = useHistory();
	const { t } = useTranslation();
	const prevRoute = getGoBackButtonInfo(history.location.state);

	return (
		<Link to={prevRoute.url}>
			<BackToAppsStyled>
				<ArrowLeftOutlined />
				{t(prevRoute.text)}
			</BackToAppsStyled>
		</Link>
	);
};
